export class SurveyLocalization {
  id: string;
  lc: string;
}
